"use strict";
/**
 * Input validation utilities for API parameters
 *
 * Provides security validation to prevent path traversal and injection attacks
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateId = void 0;
/**
 * Validates that an ID contains only safe characters
 * Allows alphanumeric, hyphens, underscores, dots, @, +, ~
 */
const isValidIdentifier = (id) => {
    return /^[a-zA-Z0-9._@+~-]+$/.test(id);
};
/**
 * Validates an ID parameter to prevent path traversal and injection
 *
 * @param id - The ID to validate
 * @param paramName - The parameter name for error messages
 * @throws Error if validation fails
 */
const validateId = (id, paramName = 'ID') => {
    // Check for null/undefined/empty
    if (!id || typeof id !== 'string' || id.trim() === '') {
        throw new Error(`${paramName} is required and must be a non-empty string`);
    }
    // Check for path traversal attempts
    if (id.includes('..') || id.includes('/') || id.includes('\\')) {
        throw new Error(`${paramName} contains invalid characters`);
    }
    // Validate identifier format (alphanumeric, hyphens, underscores)
    if (!isValidIdentifier(id)) {
        throw new Error(`${paramName} must be a valid identifier format`);
    }
    // Check length
    if (id.length > 100) {
        throw new Error(`${paramName} exceeds maximum length`);
    }
};
exports.validateId = validateId;
